import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { When } from 'react-if';
import { GlobalToken, theme } from 'antd';

import { useStores } from '@/hooks/use-stores';
import { Ports } from '@/comp/MapBuilder/components/Ports';
import { AlertsWidget } from '@/comp/MapBuilder/components/AlertsWidget';
import { CustomThemeToken } from '@/theme';
import AirFilterWidget from '@/comp/common/icons/AirFilterWidget';

import { isSelectedNodeOnMap } from '../../utils/utils';
import {
  getWidgetBorderColor,
  getWidgetBackgroundColor,
} from '../../components/SensorNodeWidget/SensorNodeWidget.utils';

const { useToken } = theme;

export const AirFilterNodeWidget = observer(({ node, engine = null, width, height }) => {
  const { filterType, inMaintenance } = node.getEntity();
  const { mapBuilderStore } = useStores();
  const { token } = useToken() as unknown as { token: CustomThemeToken };

  const renderedOnMap = !!engine;
  const isSelected = isSelectedNodeOnMap(node.device.deviceId, mapBuilderStore.selectedDevice?.deviceId, renderedOnMap);
  const borderColor = getWidgetBorderColor(isSelected, inMaintenance, renderedOnMap, token);
  const backgroundColor = getWidgetBackgroundColor(isSelected, inMaintenance, renderedOnMap, token);

  return (
    <Container width={width} height={height}>
      <AirFilterWidget width={width} height={height} borderColor={borderColor} backgroundColor={backgroundColor} />

      <When condition={!!engine}>
        <div className="name">{filterType}</div>

        <Ports node={node} engine={engine} width={width} height={height} />
      </When>

      <AlertsWidget alerts={node.alerts} className="alerts-widget" />
    </Container>
  );
});

interface ContainerProps {
  theme: { token: GlobalToken };
  width: number;
  height: number;
}

const Container = styled.div<ContainerProps>`
  position: relative;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;

  .name {
    position: absolute;
    top: -23px;
    left: 50%;
    transform: translate(-50%, 0px);
    color: ${({ theme: { token } }) => token.colorTextTertiary};
    white-space: nowrap;
    font-size: ${({ theme: { token } }) => token.fontSize}px;
  }

  .alerts-widget {
    position: absolute;
    left: 50%;
    bottom: -25px;
    transform: translate(-50%, 0px);
  }
`;
